import type { Pixel } from '@/data'
import type { PaginatedResponse, ListParams } from '@/api/client'
import { buildQuery } from '@/api/client'
import api from '..'

export type PaginatedPixels = PaginatedResponse<Pixel>

export async function getPixels(params?: ListParams): Promise<PaginatedPixels> {
  const res = await api.get('/pixels', { params: buildQuery(params) })
  return { data: res.data.data, meta: res.data.meta }
}
